<template lang="pug">
  div
    section.content-header
      h1 運営からのお知らせの詳細

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active 運営からのお知らせの詳細

    section.content

      mixin btnbar
        .row.bcard-btnbar(class!=attributes.class)
          .col-sm-4
            router-link.btn.btn-default(:to="{name: 'admin'}" title="戻る"): i.fa.fa-reply

      +btnbar

      app-messages(:errorMessages="errors", :successMessages="successes")

      .box.box-gray(v-if="isLoading")
        loading
      .box.box-gray(v-else-if="data.title")
        .bcard-info-detail
          .box-header.with-border
            .box-title
              | {{data.title}}

          .box-body
            .form-control-static
              p.text-prewrap {{data.body}}

          .box-footer.text-right
            span.text-muted 掲載期間：{{data.formatted_date_from || app_lang.NO_DATE}} ～ {{data.formatted_date_to || app_lang.NO_DATE}}

      +btnbar.-bottom
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AnnouncementRepository = RepositoryFactory.get('announcement')

export default {
  name: 'AnnouncementDetail',
  components: { AppMessages, Loading },
  props: {
    id: { type: [String, Number], required: false, default: 0 }
  },
  data () {
    return {
      data: {},
      isLoading: true
    }
  },
  created () {
    this.getAnnouncement()
  },
  methods: {
    // 運営からのお知らせ詳細を取得
    getAnnouncement () {
      const vm = this
      AnnouncementRepository.get(vm.id)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.data = data
          vm.isLoading = false

          // 既読処理
          AnnouncementRepository.read(vm.id)
            .then(function () {
              vm.$store.dispatch('reloadHeaderAnnouncements')
            })
            .catch(function (error) {
              vm.setErrorMessage(error)
            })
        })
        .catch(function (error) {
          vm.isLoading = false
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
pre {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/announcement/Detail.vue